/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
enum AssetTypes {
    '3DModel' = '3DModel',
    AutoCad = 'AutoCad',
    BIM = 'BIM',
    DerivedImage = 'DerivedImage',
    DerivedVideo = 'DerivedVideo',
    Document = 'Document',
    Image = 'Image',
    Image360 = 'Image360',
    ImageTif = 'ImageTif',
    ImageAnnotation = 'ImageAnnotation',
    Import = 'Import',
    MeasurementPDF = 'MeasurementPDF',
    MeasurementXLS = 'MeasurementXLS',
    PlyModel = 'PlyModel',
    Pointcloud = 'Pointcloud',
    SurveyVideo = 'SurveyVideo',
    TarArchive = 'TarArchive',
    Text = 'Text',
    Unknown = 'Unknwon',
    Verification = 'Verification',
    Video = 'Video',
    ZipArchive = 'ZipArchive',
}

export { AssetTypes };
